<template>
    <ContentOrLoading>
        <div class="row" v-if="! loading">
            <div class="col-12 text-center p-3">
                <div v-if="tipo_svg == 1">
                    <SvgPanZoom 
                        class="svgpanzoom-container"
                        :zoomEnabled="true"
                        :controlIconsEnabled="false"
                        :fit="true"
                        :center="true"
                        :mouseWheelZoomEnabled="false"
                        :zoomScaleSensitivity="2"
                        :dblClickZoomEnabled="false"
                        :preventMouseEventsDefault="false"
                        @svgpanzoom="registerSvgPanZoom"
                    >
                        <svg v-html="svg_loaded"/>
                    </SvgPanZoom>
                    <div class="text-center" v-if="load_panzoom">
                        <button @click="zoomIn()" class="button panzoom-button">+</button>
                        <button @click="zoomOut()" class="button panzoom-button">-</button>
                    </div>
                    <b-popover
                        v-for="plaza in plazas"
                        :key="plaza.id"
                        :target="'popover-' + plaza.id" 
                        triggers="hover"
                    >
                        <div v-if="plaza.concepto"><strong>Concepto: </strong>{{ plaza.concepto }}</div>
                    </b-popover>
                </div>
                <LeafletComponent
                    v-else
                    :svgRendered="svgRendered"
                    :originalColor="originalColor"
                    @isPanning="(e) => isPanning = e"
                />
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
    import SvgPanZoom from 'vue-svg-pan-zoom';
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import { Popover } from 'bootstrap';

    export default {
        props: ['region_id', 'tipo_svg', 'evento_id', 'sesion_id', 'recinto_id'],
        data() {
            return {
                svg_loaded : '',
                loading: true,
                svgpanzoom: null,
                svg: null,
                originalColor: '#0CBA31',
                noDisponibleColor: 'gray',
                ocupadaColor: 'red', 
                seleccionadaColor: '#8CA9D9',
                bloqueadaColor: '#BF95C4', 
                enSesionColor: 'yellow', 
                vendidaAbonosColor: 'black',
                vendidaEventosColor: 'red',
                bloqueadaAbonoColor: 'purple', 
                enSesionEventosColor: 'orange', 
                abonadoNoRenovadoColor: '#B05D04',
                validadaColor: '#01018A',
                svgRendered: null,
                isPanning: false,
                plazas: []
            }            
        },
        created() {
            this.getButacas();        
        },
        methods: {
            registerSvgPanZoom(svgpanzoom) {
                this.svgpanzoom = svgpanzoom;
            },
            zoomIn() {
                this.svgpanzoom.zoomIn();
            },
            zoomOut() {
                this.svgpanzoom.zoomOut();
            },
            getButacas() {
                this.loading = true;
                const params = {
                    recinto_id: this.recinto_id,
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    region_id: this.region_id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.regiones.plazas.taquilla'), params).then(res => {
                    this.plazas = res.data.data;
                    this.getSvg();
                }).catch(error => {
                    console.warn('Error al recuperar el SVG del recinto anexo');
                });
            },
            getSvg() {
                this.loading = true;
                let params = {
                    filters: {},
                    event_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    region_id: this.region_id
                }
                this.$store.dispatch(this.config.getVuexAlias('front.zonas.recintos-anexos.svg'), params)
                    .then(({ data: { svg } }) => {
                        if (this.tipo_svg == 1) {
                            this.loadSVG(svg);
                        } else if (this.tipo_svg == 2) {
                            this.renderLeafletSvg(svg);
                        }

                        this.loading = false;
                    }).catch(error => {
                        console.log(error);
                        console.warn('Error al recuperar el SVG del recinto anexo');
                    });
            },
            loadSVG(svg) {
                this.svg_loaded = svg;
                let vue_instance = this;
                setTimeout(() => {
                    let plazas = document.getElementsByClassName("recinto-zona");
                    for(let i in plazas) {
                        if(plazas[i].dataset !== undefined) {
                            let plaza_id = plazas[i].dataset.region;
                            for(let j in this.plazas) {
                                if (this.plazas[j].id == plaza_id) {
                                    if (!this.plazas[j].esta_disponible) {
                                        plazas[i].classList.add("plaza_ocupada");
                                    }
                                    if (this.plazas[j].esta_bloqueada) {
                                        plazas[i].classList.remove("plaza_ocupada");
                                        plazas[i].classList.add("plaza_bloqueada");
                                    }
                                }
                            }
                            plazas[i].addEventListener('click', function() {
                                vue_instance.clickRegion(this.dataset.region, plazas[i]);
                            }, false);
                        }                                                                                            
                    }
                }, 1000);                
            },
            clickRegion(plaza_id, plaza_svg = null) {
                let plaza = this.plazas.find(plaza => plaza.id == plaza_id);
                if (plaza) {
                    if (plaza.esta_bloqueada && plaza_svg) {
                        plaza_svg.classList.toggle('plaza_bloqueada');
                    }
                    this.$emit('clickZona', plaza);
                }
            },
            renderLeafletSvg(svg) {
                const plazasFiltered = this.plazas.filter(plaza => plaza.svg_id);
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = svg;

                const svgElement = tempDiv.firstElementChild;
                const butacas = svgElement.querySelectorAll('[id^="butaca"]');

                butacas.forEach(circle => {
                    circle.setAttribute('seleccionado', 'false');
                    const svg_id = this.getButacaId(circle);
                    const plaza = plazasFiltered.find(plaza => plaza.svg_id == svg_id);
                    if (plaza) {
                        const title = this.getButacaName(plaza);
                        if (plaza.libre && !plaza.ocupada.bloqueada) {     
                            this.drawPopover(circle, plaza, title);      
                            circle.style.cursor = 'pointer';
                            circle.style.transition = 'fill 0.2s';
                            circle.setAttribute('fill', this.originalColor);

                            circle.addEventListener('click', () => {
                                let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                                setTimeout(() => {
                                    if (!this.isPanning) {
                                        if (!isSeleccionado) {
                                            circle.setAttribute('fill', this.seleccionadaColor);
                                            circle.setAttribute('seleccionado', 'true');
                                        } else {
                                            circle.setAttribute('fill', this.originalColor);
                                            circle.setAttribute('seleccionado', 'false');
                                        }
                                        this.clickRegion(plaza.id);
                                    }
                                }, 150);
                            });                    
                        } else {
                            if (plaza.ocupada?.bloqueada) {
                                if (plaza.info_ocupada.concepto) {
                                    new Popover(circle, {
                                        html: true,
                                        title: title,
                                        content: '<div><strong>Concepto: </strong>' + plaza.info_ocupada.concepto + '</div>',
                                        trigger: 'hover'
                                    });
                                }
                                this.drawPopover(circle, plaza, title);      
                                circle.setAttribute('fill', this.bloqueadaColor);
                                circle.addEventListener('click', () => {
                                    let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));
    
                                    setTimeout(() => {
                                        if (!this.isPanning) {
                                            if (!isSeleccionado) {
                                                circle.setAttribute('fill', this.seleccionadaColor);
                                                circle.setAttribute('seleccionado', 'true');
                                            } else {
                                                if (plaza.etiqueta_bloqueo) {
                                                    circle.setAttribute('fill', plaza.etiqueta_bloqueo.color);
                                                } else {
                                                    circle.setAttribute('fill', this.bloqueadaColor);
                                                }
                                                circle.setAttribute('seleccionado', 'false');
                                            }
                                            this.clickRegion(plaza.id);
                                        }
                                    }, 150);
                                }); 

                                if (plaza.etiqueta_bloqueo) {
                                    circle.setAttribute('ocupada', 'true');
                                    circle.setAttribute('fill', plaza.etiqueta_bloqueo.color);
                                    this.drawPopover(circle, plaza, title); 
                                }
                            } else if (plaza.ocupada && plaza.ocupada.sesion) {
                                circle.setAttribute('ocupada', 'true');
                                circle.style.cursor = 'not-allowed';
                                circle.setAttribute('fill', this.enSesionEventosColor);
                                this.drawPopover(circle, plaza, title); 
                            } else if (plaza.ocupada && plaza.ocupada.venta) {
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.vendidaEventosColor);
                                circle.style.cursor = 'not-allowed';
                                this.drawPopover(circle, plaza, title); 
                            } else if (plaza.ocupada && plaza.ocupada.bloqueada_abonos) {
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.bloqueadaAbonoColor);
                                circle.style.cursor = 'not-allowed';
                                this.drawPopover(circle, plaza, title); 
                            } else if (plaza.ocupada && plaza.ocupada.comprada_abonos && plaza.ocupada.renovado) {
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.vendidaAbonosColor);
                                circle.style.cursor = 'not-allowed';

                                let content

                                if (plaza.info_ocupada.numero_pedido) {
                                    circle.style.cursor = 'pointer';
                                    content = '<div><strong>Nº del pedido: </strong>' + plaza.info_ocupada.numero_pedido + '</div>';

                                    circle.addEventListener('click', () => {
                                        let url = `/admin/eventos/${this.evento_id}/sesiones/${this.sesion_id}/ventas?n_pedido=${plaza.info_ocupada.numero_pedido}`;
                                        window.open(url, '_blank');
                                    });
                                }
                                this.drawPopover(circle, plaza, title, content); 
                            } else if (plaza.ocupada && plaza.ocupada.comprada_abonos && !plaza.ocupada.renovado) {
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.abonadoNoRenovadoColor);
                                circle.style.cursor = 'not-allowed';

                                let content

                                if (plaza.info_ocupada.numero_pedido) {
                                    circle.style.cursor = 'pointer';
                                    content = '<div><strong>Nº del pedido: </strong>' + plaza.info_ocupada.numero_pedido + '</div>';

                                    circle.addEventListener('click', () => {
                                        let url = `/admin/eventos/${this.evento_id}/sesiones/${this.sesion_id}/ventas?n_pedido=${plaza.info_ocupada.numero_pedido}`;
                                        window.open(url, '_blank');
                                    });
                                }
                                this.drawPopover(circle, plaza, title, content); 
                            } else if (plaza.ocupada && plaza.ocupada.en_sesion_abonos) {
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.enSesionColor);
                                circle.style.cursor = 'not-allowed';
                                this.drawPopover(circle, plaza, title); 
                            }
                        }
                        if (plaza.info_acceso?.accedido) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.validadaColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title);
                        }
                    }
                });

                this.svgRendered = tempDiv.firstElementChild;
            },
            drawPopover(circle, plaza, title = null, content = '') {
                if (plaza.ocupada) {
                    if (plaza.etiqueta_bloqueo) {
                        content += `<div><strong>` + plaza.etiqueta_bloqueo.name + `</strong></div>`;
                    }

                    if (plaza.ocupada.bloqueada) {
                        content += `<div><strong>Plaza bloqueada</strong></div>`;
                    } else if (plaza.ocupada.venta) {
                        content += `<div><strong>Vendida</strong></div>`;
                    } else if (plaza.ocupada.sesion) {
                        content += `<div><strong>En sesión</strong></div>`;
                    } else if (plaza.ocupada.comprada_abonos) {
                        if (plaza.ocupada.renovado) {
                            content += `<div><strong>Vendida en abono</strong></div>`;
                        } else {
                            content += `<div><strong>Butaca de abonado sin renovar</strong></div>`;
                        }
                    } else if (plaza.ocupada.bloqueada_abonos) {
                        content += `<div><strong>Bloqueada en abonos</strong></div>`;
                    } else if (plaza.ocupada.en_sesion_abonos) {
                        content += `<div><strong>En sesión en abono</strong></div>`;
                    }
                    if (plaza.ocupada.comprada_abonos && !plaza.ocupada.renovado) {
                        content += `<div><strong>Abonado no renovado</strong></div>`;
                    }
                    if(plaza.info_ocupada?.numero_pedido){
                        content = '<div><strong>Nº del pedido: </strong>' + plaza.info_ocupada.numero_pedido + '</div>';

                        circle.addEventListener('click', () => {
                            let url = `/admin/eventos/${this.evento_id}/sesiones/${this.sesion_id}/ventas?n_pedido=${plaza.info_ocupada.numero_pedido}`;
                            window.open(url, '_blank');
                        });
                    }

                    if (plaza.ocupada.venta && plaza.info_ocupada?.nombre_venta && plaza.info_ocupada?.apellidos_venta) {
                        content += `<div><strong>Nombre: </strong>${plaza.info_ocupada.nombre_venta + ' ' + plaza.info_ocupada.apellidos_venta}</div>`;
                    }
                }

                if (plaza.info_acceso && plaza.info_acceso.accedido) {
                    content += `<div><strong>Hora de acceso: </strong>` + plaza.info_acceso.hora_acceso + `</div>`;
                }

                if (plaza.libre) {
                    content = `<div><strong>Plaza libre</strong></div>`;
                }

                const popoverOptions = {
                    title: title,
                    content: content,
                    trigger: 'hover',
                    html: true
                };

                new Popover(circle, popoverOptions);
            },
            getButacaName(butaca) {
                const nButaca = butaca.butaca;
                const nFila = butaca.fila;
                const sector = butaca.sector_name;
                const visibilidad_reducida = butaca.visibilidad_reducida;
                const porcentaje_visibilidad = butaca.porcentaje_visibilidad;
                let name = '';

                if (sector) {
                    name += `Sector: ${sector} - `;
                }

                if (!nButaca && !nFila) {
                    name += `Plaza: ${butaca.numero}`;
                } else {
                    name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                }

                if (visibilidad_reducida) {
                    name += '<span class="text-danger"> Visibilidad Reducida</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },
            getButacaId(circle) {
                const id = circle.id;
                const idParts = id.split("-");

                return idParts[1];
            }
        },
        computed: {
            load_panzoom() {
                let load_panzoom = true
                let userAgent = navigator.userAgent || navigator.vendor || window.opera;
                if(/windows phone/i.test(userAgent)) {
                    load_panzoom = false;
                }
            
                if(/android/i.test(userAgent)) {
                    load_panzoom = false;
                }
                if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    load_panzoom = false;
                }
                return load_panzoom;
            },
        },
        components: { SvgPanZoom, LeafletComponent }
    }
</script>